import { SVGProps } from "react";

import { LargeSizeType } from "mds/global-types";

export type StatusColorType = "gray" | "green" | "orange" | "red";

export const COLOR_TO_FILL_CLASS: Record<StatusColorType, string> = {
  gray: "fill-black-tint-70",
  green: "fill-green",
  orange: "fill-orange",
  red: "fill-red",
};

export const ICON_SIZES: Record<LargeSizeType, number> = {
  xs: 12,
  s: 14,
  m: 16,
  l: 20,
  xl: 24,
  xxl: 28,
  xxxl: 32,
};

export type IconProps = SVGProps<SVGSVGElement> & {
  size?: LargeSizeType;
};

export type StatusIconProps = IconProps & {
  statusColor: StatusColorType;
};

/*
 * Initializes svg properties for an icon.  Mainly we use this to add
 * sizing to each icon in one place.
 */
export const initializeSvgIconProps = ({ size = "m", ...svgProps }: IconProps) => {
  return {
    fill: "none",
    height: ICON_SIZES[size],
    viewBox: "0 0 16 16",
    width: ICON_SIZES[size],
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
  };
};

export const initializeStatusIconProps = ({ statusColor, ...svgProps }: StatusIconProps) => {
  return {
    statusClassName: COLOR_TO_FILL_CLASS[statusColor],
    ...initializeSvgIconProps(svgProps),
  };
};
